import css from "./css/leftpanel.module.css";

export default function RightPanel() {
  return <div className={`${css.panel_head}`}>Chart Types</div>;
}
